export default __webpack_public_path__ + "static/media/us-interstate.b84f7c3b.svg";